import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * blanky: keeps <blanky-preorder-status> in sync with the selected variant.
 * Follows the same pattern as the theme's product-inventory component: on product select,
 * take the matching element from the re-rendered section HTML and morph it in.
 */
class BlankyPreorderStatus extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {Event & { promise?: Promise<{ detail?: { html?: Document, productId?: string, newProduct?: { id: string } } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail } = {}) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = html.querySelector(`blanky-preorder-status[data-block-id="${this.dataset.blockId}"]`);
        if (!(next instanceof HTMLElement)) return;

        this.dataset.preorder = next.dataset.preorder ?? 'false';
        this.dataset.hidePrice = next.dataset.hidePrice ?? 'false';
        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[blanky-preorder-status] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('blanky-preorder-status')) {
  customElements.define('blanky-preorder-status', BlankyPreorderStatus);
}